import { MessageCircle, ShieldCheck } from "lucide-react";
import { StatusBadge } from "@/components/admin/JenisTag";
import { formatDateID } from "@/lib/format";
import { cn } from "@/lib/utils";

const NOTIFY_LABEL = { sent: "terkirim", failed: "gagal", skipped: "tidak dikirim" };

const NotifyLine = ({ update }) => (
  <p className="mt-2 text-[11px] text-slate-500" data-testid="timeline-notify-status">
    Notifikasi · Email: {NOTIFY_LABEL[update.notify_email] || "memproses..."} · WhatsApp: {NOTIFY_LABEL[update.notify_whatsapp] || "memproses..."}
  </p>
);

const TimelineItem = ({ update, index, viewer }) => {
  const isAdmin = update.author_role === "admin";
  const Icon = isAdmin ? ShieldCheck : MessageCircle;
  return (
    <li className="relative flex gap-3" data-testid={`timeline-item-${index}`}>
      <span className={cn("relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ring-4 ring-white", isAdmin ? "bg-emerald-600 text-white" : "bg-slate-200 text-slate-700")}>
        <Icon className="h-4 w-4" />
      </span>
      <div className={cn("min-w-0 flex-1 rounded-2xl border p-4", isAdmin ? "border-emerald-200 bg-emerald-50/60" : "border-slate-200 bg-white")}>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs">
          <span className="font-semibold text-slate-900">{isAdmin ? "Pengurus RT" : update.author_name}</span>
          {isAdmin ? (
            <span className="rounded-full bg-white px-2 py-0.5 font-semibold text-emerald-700 ring-1 ring-emerald-200" data-testid={`timeline-date-${index}`}>
              Progres {formatDateID(update.tanggal, "d MMM yyyy")}
            </span>
          ) : (
            <span className="text-slate-400">Balasan warga</span>
          )}
          {update.status && <StatusBadge status={update.status} />}
          <span className="ml-auto text-slate-400">{formatDateID(update.created_at, "d MMM yyyy, HH:mm")}</span>
        </div>
        <p className="mt-2 whitespace-pre-wrap break-words text-sm leading-relaxed text-slate-700" data-testid={`timeline-message-${index}`}>{update.message}</p>
        {viewer === "admin" && isAdmin && <NotifyLine update={update} />}
      </div>
    </li>
  );
};

export const ProgressTimeline = ({ updates, viewer = "warga" }) => {
  if (!updates?.length) {
    return (
      <p className="rounded-2xl border border-dashed border-slate-300 p-6 text-center text-sm text-slate-500" data-testid="timeline-empty">
        Belum ada progres atau tanggapan dari pengurus RT.
      </p>
    );
  }
  return (
    <ol className="relative space-y-4 before:absolute before:left-[15px] before:top-3 before:h-[calc(100%-1.5rem)] before:w-px before:bg-slate-200" data-testid="progress-timeline">
      {updates.map((u, i) => (
        <TimelineItem key={u.id} update={u} index={i} viewer={viewer} />
      ))}
    </ol>
  );
};
